import { ISODateString } from '@app/shared/utils/date-string.util';
import moment from 'moment';
import { User } from '../user/user.model';
import { FrankliEventStatus } from './frankli-event-status.enum';
import { FrankliNotificationType } from './frankli-event-type.enum';

export interface FrankliNotificationServerside {
  id: number;
  userId: number;
  eventType: FrankliNotificationType;
  eventForeignId: number;
  timestamp: ISODateString;
  url: string;
  imageUrl: string;
  text: string;
  eventStatus: FrankliEventStatus;
  action: boolean;
  event: boolean;
}

export class FrankliNotification {
  public id: number;
  public userId: number;
  public eventType: FrankliNotificationType;  // TODO: rename to 'type' of type 'FrankliNotificationType'
  public eventForeignId: number;
  public timestamp: Date;
  public url: string;
  public imageUrl: string;
  public text: string;
  public eventStatus: FrankliEventStatus;  // TODO: rename to 'status' of type 'FrankliNotificationStatus'
  public action: boolean;
  public event: boolean;
  public user?: User;
  public viewed?: boolean;

  constructor(frankliNotificationServerside: FrankliNotificationServerside) {
    this.id = frankliNotificationServerside.id;
    this.userId = frankliNotificationServerside.userId;
    this.eventType = frankliNotificationServerside.eventType;
    this.eventForeignId = frankliNotificationServerside.eventForeignId;
    this.timestamp = moment.utc(frankliNotificationServerside.timestamp).toDate();
    this.url = frankliNotificationServerside.url;
    this.imageUrl = frankliNotificationServerside.imageUrl;
    this.text = frankliNotificationServerside.text;
    this.eventStatus = frankliNotificationServerside.eventStatus;
    this.action = frankliNotificationServerside.action;
    this.event = frankliNotificationServerside.event;
  }

}
